module.exports = __webpack_public_path__ + "img/shopping-cart-white.9a5074f5.svg";